var React = require('react');

function FileDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#3434ee","fillOpacity":"0.8","d":"M32 62l30-30h-18v-32h-24v32h-18z"}));
}

FileDownload.defaultProps = {"version":"1.1","width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = FileDownload;

FileDownload.default = FileDownload;
